export default __webpack_public_path__ + "static/media/icon_minus.855e69ff.svg";